export enum ErrorMessages {
    UnableToReply = 'An Unknown Error Occurred While Adding the comment: undefined|Request has been terminated Possible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.',
    UnableToChangeMessageStatus = 'Unable to change the read status of a comment',
    UnableToLoadAllComments = 'Unable to load all the comments of the document',
    AddReplySuccess = 'Success! A new comment was added to ',
}
